import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal-dismiss"
// Handles dismissing warning and time-up modals in quiz sections
export default class extends Controller {
  dismissWarning(event) {
    event.preventDefault()
    window.$("#interface-modal-warning-container-yash").remove()
  }

  dismissTimeUp(event) {
    event.preventDefault()
    window.$("#interface-modal-timeup-container-yash").remove()
  }
}
